/**
 * Context for the Common Balance Pool builder (cf. TPAllocationContext / CalculationBuilderContext).
 * Children (the inputs modal, the Step-2 section) consume this instead of receiving prop-threaded
 * cross-cutting state. `persistColumns` is the single UpdateCommonBalancePool choke point (with the
 * dangling-reference guard), shared by the input remove/edit paths and Step-2 saves.
 */
import React from 'react';
import TPEAction from 'src/models/common/TPEAction';
import ServiceCollection from 'src/services/ServiceCollection';
import { CommonBalancePoolColumn } from 'src/models/multidimensional-allocation/CommonBalancePool';
import { CommonBalancePoolBuilderState } from 'src/services/multidimensional-allocation/common-balance-pool/CommonBalancePoolBuilderState';

export type CommonBalancePoolBuilderContextType = {
    cbpBuilderState: CommonBalancePoolBuilderState;
    cbpBuilderDispatch: React.Dispatch<TPEAction>;
    services: ServiceCollection;
    poolId: string;
    canEdit: boolean;
    /** Persist the next column set via UpdateCommonBalancePool; returns success. */
    persistColumns: (next: CommonBalancePoolColumn[]) => Promise<boolean>;
};

export const CommonBalancePoolBuilderContext = React.createContext(null as unknown as CommonBalancePoolBuilderContextType);
